import { render } from "./StoreTaskConfigurationView.vue?vue&type=template&id=c5dcac44&scoped=true&ts=true"
import script from "./StoreTaskConfigurationView.vue?vue&type=script&lang=ts"
export * from "./StoreTaskConfigurationView.vue?vue&type=script&lang=ts"

import "./StoreTaskConfigurationView.vue?vue&type=style&index=0&id=c5dcac44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5dcac44"]])

export default __exports__